'use strict'
module.exports = {
  NODE_ENV: '"production"',
  apiUrl: '"https://bjmuseum.org.cn/admin/"' //线上环境接口路径
  //apiUrl: '"http://192.168.5.101/admin"' //线上环境接口路径
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1